export function hexToInput(hex) {
  return `#${  hex.toString(16).padStart(6, "0")}`
}

export function inputToHex(value) {
  return parseInt(value.replace("#", ""), 16)
}

export function formatNumber(n) {
  return n.toLocaleString()
}
